function init() {

  const languages = ['.menu-language-container', '.menu-language-english-container', '.menu-language-russian-container']

  languages.forEach((language) => {
	  const mobileLangnavigationDropdownLink  = document.querySelector(`.mobilemainnavigation__langnavigationdropdownlink ${language} ul > li > a`);
	  const mobileLangnavigationSubmenu       = document.querySelector(`.mobilemainnavigation ${language} .sub-menu`);
	  // add event listener to mobile langnavi dropdown link
	  if (mobileLangnavigationDropdownLink) {
	    mobileLangnavigationDropdownLink.addEventListener('click', (e) => {
	      e.preventDefault();

	      // toggle mobile langnavi submenu
	      if (mobileLangnavigationSubmenu) {
	        mobileLangnavigationSubmenu.classList.toggle('sub-menu--open');
	      }
	    });
	  }
  });

  // const mobileLangnavigationDropdownLink  = document.querySelector('.mobilemainnavigation__langnavigationdropdownlink .menu-language-container ul > li > a');
  // const mobileLangnavigationSubmenu       = document.querySelector('.mobilemainnavigation .menu-language-container .sub-menu');

}

export default init;



// WEBPACK FOOTER //
// ./wp-content/themes/template/res/js/modules/Mobilelangnavigation.js